import {
  ICohortRefFieldsFragment,
  IMeasureFieldsFragment,
  IMeasurePropertiesFieldsFragment,
  ISimpleMeasureFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import { UnreachableCaseError } from 'ts-essentials';

export interface IBuilderSimpleMeasureInfo {
  simpleMeasure: ISimpleMeasureFieldsFragment;
  cohorts: ICohortRefFieldsFragment[];
}

interface IParsedMeasureInfo {
  measures: IBuilderSimpleMeasureInfo[];
  formula: string | null;
}

/**
 * A function will parse Simple or Compound measure with measure properties
 * for BuilderInfo popup
 */
export const parseMeasureInfo = (
  measure: IMeasureFieldsFragment,
  measureProperties: IMeasurePropertiesFieldsFragment | null,
): IParsedMeasureInfo => {
  if (measure.__typename === 'SimpleMeasure') {
    const cohorts =
      measureProperties &&
      measureProperties.__typename === 'SimpleMeasureProperties'
        ? measureProperties.cohortRefs
        : [];

    return {
      measures: [
        {
          simpleMeasure: measure,
          cohorts,
        },
      ],
      formula: measure?.formula ?? null,
    };
  } else if (measure.__typename === 'CompoundMeasure') {
    const { measures } = measure;

    return {
      measures: measures.map((simpleMeasure, index) => {
        const cohorts =
          measureProperties &&
          measureProperties.__typename === 'CompoundMeasureProperties'
            ? measureProperties.measures[index].cohortRefs
            : [];

        return {
          simpleMeasure,
          cohorts,
        };
      }),
      formula: measure?.formula ?? null,
    };
  } else {
    throw new UnreachableCaseError(measure);
  }
};
